import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import get from 'lodash/get';
import Button from 'yoda-core-components/lib/components/Button/Button';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import RichText from '../RichText/RichText';

const cx = classNames.bind();

const renderItems = (children) => {
    const items = children.map((element) => (
        <React.Fragment key={element.key}>{element}</React.Fragment>
    ));
    return items;
};
export const ctaLinkClick = (event, link, openInNewTab) => {
    event.preventDefault();
    const linkTarget = openInNewTab ? '_blank' : '_self';
    window.open(link, linkTarget);
};

const shopAllButtonRender = (dataItem, styleABtn) => {
    const ctaLink = get(dataItem, 'link.url', '');
    const linkText = get(dataItem, 'linkText', '');
    const openInNewTab = get(dataItem, 'openInNewTab', false);
    if (linkText && ctaLink) {
        /* istanbul ignore next */
        return (
            <Button
                type="linkbutton"
                linkUrl={ctaLink}
                onClick={(event) => ctaLinkClick(event, ctaLink, openInNewTab)}
                buttonType="Secondary"
                className={styleABtn}
            >
                <RichText text={linkText} />
            </Button>
        );
    }
    return null;
};

const Structure = (props) => {
    const children = React.Children.toArray(props.children);
    const { styleTheme, contentBlock, styleABtn, footerBlock, showCtaButton } = props;
    /* istanbul ignore next */
    if (props.count && children.length !== props.count) {
        throw new Error(`If you supply value (${props.count}) to length props then it is
        expected to have (${props.count}) items as children item to render. It is an optional parameter!`);
    }
    // TODO: need to remove this console once the refactoring is done
    return (
        <div
            data-automation-id={props.automationId}
            className={`${dt(['relative'])} ${cx('mainContainerBlock', styleTheme)}`}
        >
            {/* Container Content Block */}
            <div
                data-automation-id="structure-content-block"
                className={`${dt(['flex', 'w-full', 'items-stretch', 'flex-wrap'])} ${cx(
                    'structureContentBlock',
                    contentBlock
                )}`}
            >
                {renderItems(children)}
            </div>
            {
                /* istanbul ignore next */
                showCtaButton ? (
                    <div
                        data-automation-id="structure-footer-block"
                        className={`${dt(['hidden'])} ${cx('structureFooterBlock', footerBlock)}`}
                    >
                        {shopAllButtonRender(props.dataItem, styleABtn)}
                    </div>
                ) : null
            }
            {/* Container Content Block Ends */}
        </div>
    );
};

Structure.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]).isRequired,
    count: PropTypes.element,
    dataItem: PropTypes.object,
    automationId: PropTypes.string,
    styleTheme: PropTypes.string,
    contentBlock: PropTypes.string,
    styleABtn: PropTypes.string,
    footerBlock: PropTypes.string,
    showCtaButton: PropTypes.bool,
};

Structure.defaultProps = {
    count: null,
    dataItem: {},
    automationId: 'structure',
    styleTheme: '',
    contentBlock: '',
    styleABtn: '',
    footerBlock: '',
    showCtaButton: true,
};

export default Structure;
